/**
 * `init({ platform })` normalization, shared by `widget.js` and
 * `widget-host.js`. Attribution only: a value outside the closed lowercase
 * shape is dropped (never sent), so a typo cannot widen metric cardinality
 * or smuggle anything into a URL.
 */
export function normalizePlatform(value: unknown): string | null {
  return typeof value === 'string' && /^[a-z][a-z0-9_-]{0,31}$/.test(value) ? value : null;
}
